import { useTheme } from '@emotion/react'
import { Section } from 'chaoskit/src/components'
import { StylesContainerVariables } from 'chaoskit/src/components/Container'
import { darkBluePurple } from 'chaoskit/src/assets/styles/utility/gradient'

import { ReactComponent as FooterCTASVG } from '~media/global/footer-graphic.svg'
import ButtonLink from '~components/ButtonLink'

const FooterCTA = () => {
  const theme = useTheme()

  return (
    <Section
      css={{ ...darkBluePurple(theme), overflow: 'hidden' }}
      className="u-contrast"
    >
      <div
        css={{
          paddingLeft: theme.space.base,
          paddingRight: theme.space.base,
          maxWidth: StylesContainerVariables.base,
          display: 'grid',
          margin: '0 auto',
          gap: theme.space.base,
          alignItems: 'center',

          [theme.mq.medium]: {
            gridTemplateColumns: 'repeat(12, minmax(0, 1fr))',
            gap: 0,
            paddingTop: theme.space.large,
          },
        }}
      >
        <div
          css={{
            position: 'relative',
            zIndex: 1,

            [theme.mq.medium]: {
              gridRow: 1,
              gridColumn: '1 / span 6',
            },
          }}
        >
          <h3 css={{ ...theme.headingPreset.h2 }}>
            Avoid downtime. Use Gremlin to turn failure into resilience.
          </h3>
          <p css={{ ...theme.text.medium }}>
            Gremlin empowers you to proactively root out failure before it
            causes downtime. See how you can harness chaos to build resilient
            systems by requesting a demo of Gremlin.
          </p>
          <ButtonLink
            css={{ marginTop: theme.space.large }}
            type="secondary"
            url="/get-started/?ref=footer"
          >
            Get started
          </ButtonLink>
        </div>
        <div
          css={{
            position: 'relative',

            [theme.mq.medium]: {
              gridRow: 1,
              gridColumn: '7 / span 6',
            },
          }}
        >
          <FooterCTASVG
            css={{
              [theme.mq.medium]: {
                position: 'absolute',
                left: 0,
                top: 0,
                transform: 'translateY(-47.5%)',
                maxWidth: 'none',
                height: '850px',
              },
            }}
          />
        </div>
      </div>
    </Section>
  )
}

export default FooterCTA
